// @ts-ignore
import { registerSW } from 'virtual:pwa-register';

registerSW({
	immediate: true,
});
